import { useLocation, useNavigate } from 'react-router-dom'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/select-dropdown'
import { PARTNERS_PAGE_TABS } from '@/data/constants'
import { getLastRoutePath } from '@/utils/route-utils'

const MobileTabMenu = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const selectedTab = getLastRoutePath(pathname)

  const handleTabChange = value => {
    navigate(value)
  }

  // Determine the screen width dynamically
  const screenWidth = window.innerWidth

  return (
    <Select value={selectedTab} onValueChange={handleTabChange}>
      <SelectTrigger className={screenWidth < 430 ? 'w-full' : 'w-[120%]'}>
        <SelectValue placeholder="Selected Tab" />
      </SelectTrigger>
      <SelectContent className="bg-white">
        {Object.entries(PARTNERS_PAGE_TABS).map(([key, tab]) => (
          <SelectItem key={key} value={key} className={`${selectedTab === key ? 'bg-dGray-100' : ''}`}>
            {tab.title}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}

export default MobileTabMenu
